import {isDevMode} from '@angular/core';
import * as moment from 'moment';
/* tslint:disable */
export abstract class BaseService {
  protected log(message?: any, ...optionalParams: any[]): void {
    if (isDevMode()) {
      console.log(`[${this.getTimestamp()}] ${message}`, optionalParams); // tslint:disable-line
    }
  }

  protected warn(message?: any, ...optionalParams: any[]): void { console.warn(`[${this.getTimestamp()}] ${message}`, optionalParams); }

  protected error(message?: any, ...optionalParams: any[]): void { console.error(`[${this.getTimestamp()}] ${message}`, optionalParams); }

  private getTimestamp(): string {
    const now = moment();
    return now.format('DD/MM/YYYY HH:mm:ss.SSS');
  }
}
